module.exports = __webpack_public_path__ + "static/media/accessory7.aed6b71f.webp";